import {getApiUrl} from "../utils/util-functions";

export const getFullstackPublicApiKey = async () => {
    return fetch(getApiUrl() + '/payment/fullstack/public-api-key', {
        method: 'GET'
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'] as {'public-key': string};
        });
};